import React from "react";
import { Helmet } from "react-helmet";
import Services from "../../components/services/Services";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import ServiceDetail from "../../components/service-detail/Services";

import banner from "../../assets/img/service-banner1.avif";

const data = {
  title: "Project Management Consulting Services",
  url: "project-management",
  banner: banner,
  desc1:
    "At GGAS Maintenance Tooling &amp; Equipments (GGAS), our project management consulting practice delivers proven, cost-effective solutions that drive high-impact results. With a strong track record of success, our consultants not only lead critical initiatives to completion but also empower your team by embedding structured, scalable project management practices.",
  desc2:
    "Whether you need hands-on leadership, guidance on project governance, or support building internal capabilities, our team adapts to your organization’s needs—delivering immediate results while fostering long-term growth. We offer a flexible, tiered approach with three levels of consultants, enabling us to support projects of all sizes and complexities.",
  common:
    "Our services include project leadership, PMO setup, team mentoring, and customized training, ensuring your teams are equipped for sustainable success.",
  mainTitle: "Our Project Management Team",
  list: [
    {
      id: 1,
      title: "Senior Project Management Consultant",
      desc: "Senior Consultants lead complex, cross-functional initiatives and strategic programs. They bring deep expertise and facilitate:",
      items: [
        "Development of program charters to align scope and goals",
        "Creation of high-level and detailed schedules using network-based planning",
        "Identification of key activities, durations, responsibilities, and resource needs",
        "Time-cost optimization, schedule validation, and compression",
        "Staffing assessments and resource planning",
        "Implementation of governance frameworks, metrics, and reporting structures",
        "Design and deployment of full-scale Project Management Offices (PMOs)",
      ],
    },
    {
      id: 2,
      title: "Project Management Consultant",
      desc: "Our Project Management Consultants manage small to mid-sized projects, coordinating teams and driving execution. They regularly provide:",
      items: [
        "Definition of project scope and objectives through program charters",
        "Development of Work Breakdown Structures (WBS) and activity mapping",
        "Scheduling and resource planning using modern project management tools",
        "Schedule review, validation, and compression techniques",
        "Stakeholder updates through structured status reporting",
        "Coaching on project methodologies and tool usage",
      ],
    },
    {
      id: 3,
      title: "Project Management Coordinator",
      desc: "Project Coordinators support project execution under the direction of Senior Consultants or Consultants. They serve as a critical operational link, performing:",
      items: [
        "Preparation of stakeholder reports and progress dashboards",
        "Identification of risks or delays requiring escalation",
        "Data entry and maintenance in project management systems",
        "Regular updates to schedules, documentation, and project repositories",
        "Maintenance of shared drives, databases, and project portals",
        "Support as subject-matter experts on project management software",
      ],
    },
  ],
  footer:
    "Partner with GGAS to bring structure, clarity, and measurable results to your most important projects. Whether you're launching a new initiative or enhancing existing processes, we’re ready to support your success with tailored, expert-led project management solutions.",
};

function ServiceDetailPage({ setShow }) {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{data.title} | GGAS</title>
        <meta name="keyword" content="GGAS" />
        <meta name="description" content="GGAS" />
      </Helmet>
      <Breadcrumb title={data.title} t={t} />
      <ServiceDetail data={data} />
    </>
  );
}

export default ServiceDetailPage;
